import { __extends } from "tslib";
import { FreeCamera } from "./freeCamera";
import { Vector3 } from "../Maths/math.vector";
import { Node } from "../node";
Node.AddNodeConstructor("TouchCamera", function (name, scene) {
    return function () { return new TouchCamera(name, Vector3.Zero(), scene); };
});
/**
 * This represents a FPS type of camera controlled by touch.
 * This is like a universal camera minus the Gamepad controls.
 * @see https://doc.babylonjs.com/features/cameras#universal-camera
 */
var TouchCamera = /** @class */ (function (_super) {
    __extends(TouchCamera, _super);
    /**
     * Instantiates a new touch camera.
     * This represents a FPS type of camera controlled by touch.
     * This is like a universal camera minus the Gamepad controls.
     * @see https://doc.babylonjs.com/features/cameras#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */
    function TouchCamera(name, position, scene) {
        var _this = _super.call(this, name, position, scene) || this;
        _this.inputs.addTouch();
        _this._setupInputs();
        return _this;
    }
    Object.defineProperty(TouchCamera.prototype, "touchAngularSensibility", {
        /**
         * Defines the touch sensibility for rotation.
         * The higher the faster.
         */
        get: function () {
            var touch = this.inputs.attached["touch"];
            if (touch) {
                return touch.touchAngularSensibility;
            }
            return 0;
        },
        set: function (value) {
            var touch = this.inputs.attached["touch"];
            if (touch) {
                touch.touchAngularSensibility = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TouchCamera.prototype, "touchMoveSensibility", {
        /**
         * Defines the touch sensibility for move.
         * The higher the faster.
         */
        get: function () {
            var touch = this.inputs.attached["touch"];
            if (touch) {
                return touch.touchMoveSensibility;
            }
            return 0;
        },
        set: function (value) {
            var touch = this.inputs.attached["touch"];
            if (touch) {
                touch.touchMoveSensibility = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets the current object class name.
     * @return the class name
     */
    TouchCamera.prototype.getClassName = function () {
        return "TouchCamera";
    };
    /** @hidden */
    TouchCamera.prototype._setupInputs = function () {
        var touch = this.inputs.attached["touch"];
        var mouse = this.inputs.attached["mouse"];
        if (mouse) {
            mouse.touchEnabled = false;
        }
        else {
            touch.allowMouse = true;
        }
    };
    return TouchCamera;
}(FreeCamera));
export { TouchCamera };
//# sourceMappingURL=touchCamera.js.map